import React from 'react';
import { formatINR } from 'utils';

const ProductDetails = ({
  product,
  pincode,
  setPincode,
  checkAvailability,
  message,
  deliveryDate,
}: any) => (
  <div className='step2-right'>
    <h2>{product?.productName}</h2>
    <p>
      <strong>Price: </strong>
      {Number(product?.discountedAmount) > 0 ? (
        <>
          <s className="original-price">
            {formatINR(product?.price)}
          </s>{" "}
          <b className="discounted-price">
            {formatINR(product?.discountedPrice)}
          </b>
        </>
      ) : (
        <b className="discounted-price">
          {formatINR(product?.price)}
        </b>
      )}
    </p>


    <p>
      <strong>Purity:</strong> {`${product?.purity}%`}
    </p>
    <p>
      <strong>Quantity:</strong> 1 Unit
    </p>

    <h4>Product Description:</h4>
    <p>{product?.productDescription}</p>

    <h4>Check Delivery Availability:</h4>
    <div className='pincode-check'>
      <input
        type='text'
        placeholder='Enter Pincode'
        value={pincode}
        maxLength={6}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d{0,6}$/.test(value)) setPincode(value);
        }}
      />
      <button onClick={checkAvailability}>Check</button>
    </div>
    {message && (
      <p className='message'>
        {message} {deliveryDate ? `(${deliveryDate})` : ''}
      </p>
    )}
  </div>
);

export default ProductDetails;
